// export const BASE_URL = "http://127.0.0.1:8000";
export const BASE_URL = "https://researchrider.xyz";
export const BASE_IMG = `https://researchrider.s3.amazonaws.com`;
